<template>
     <div>
         <select :class="className"   v-model="inputVal" @change="change">
             <optgroup v-if="getPrinterTypesUsed.favourite.length>0" :label="'- ' + $t('printers.select.fav')"></optgroup>
             <option v-for="(item, index) in getPrinterTypesUsed.favourite" :key="index + '_f'" :value="item.id">{{item.description}}</option>
             <optgroup v-if="getPrinterTypesUsed.my.length>0" :label="'- ' + $t('printers.select.my')"></optgroup>
             <option v-for="(item, index) in getPrinterTypesUsed.my" :key="index + '_my'" :value="item.id">{{item.description}}</option>
             <optgroup :label="'- ' + $t('printers.select.all')"></optgroup>
             <option v-for="(item, index) in getPrinterTypesUsed.all"   :key="index + '_all'" :value="item.id">{{item.description}}</option>
         </select>

     </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import PrinterTypeMixin from "../../mixins/printerType";
  export default {
    name: "PrinterSelect",
    props: ['value', 'className', 'fileId'],
    mixins: [PrinterTypeMixin],
    computed: {
      ...mapGetters(['isPrinterTypesLoaded', 'getPrinterTypesUsed']),
      inputVal: {
        get() {
          if (this.value) {
            return this.value;
          }
          const lastUsedPrinterTypeId = this.getLastUsedPrinterTypeId(this.fileId);
          if (lastUsedPrinterTypeId) {
            return lastUsedPrinterTypeId;
          }
          const types = this.getPrinterTypesUsed;
          if (types.favourite.length > 0) {
            return types.favourite[0].id;
          }
          if (types.my.length > 0) {
            return types.my[0].id;
          }

          return this.getPrimaryPrinterTypeId();
        },
        set(val) {
          this.$emit('input', val);
        }
      }
    },
    methods:{
      ...mapActions(['fetchPrinterTypes']),

      change(event){
        this.$emit('change', event.srcElement.value);
      }
    },
    created() {
      if(!this.isPrinterTypesLoaded){
        this.fetchPrinterTypes()
      }
      this.$emit('input', this.inputVal);
    }
  }
</script>

<style scoped>

</style>
